import { actionsProperties } from "../types";
import CropActions from "./crop-actions";

const Actions = ({
  service,
  property,
  clickDownloadHandler,
  clickResetHandler,
  clickCropHandler,
  downloadImage,
  sendDownloadEvent,
  dispatch,
  setCanvasDimensions,
  setCropDimensions, 
  setCanvasInputValue,
  setCropValidation,
  sendClickResset,
  setCropPosition,
  canvasRef,
  getCanvasImage,
  changeImage,
  sendClickCrop

}: actionsProperties) => {
  return (
    <div className="service__actions">
      <CropActions
        service={service}
        isAddedImage={!!property.image}
        canvasWidth={property.analyticsInfo.widthOut}
        canvasHeight={property.analyticsInfo.heightOut}
        clickResetHandler={clickResetHandler}
        clickCropHandler={clickCropHandler}
        setCropDimensions={setCropDimensions}
        setCanvasDimensions={setCanvasDimensions}
        setCanvasInputValue={setCanvasInputValue}
        setCropValidation={setCropValidation}
        setCropPosition={setCropPosition}
        sendClickResset={sendClickResset}
        dispatch={dispatch}
        image={property.image}
        cropInfo={{ position: property.cropPosition, dimensions: property.cropDimensions }}
        createImage={getCanvasImage}
        changeImage={changeImage}
        sendClickCrop={sendClickCrop}
        canvasRef={canvasRef} 
        canvasFormat={property.imageType} />
      <button
        className="service__control-download_btn btn btn__primary"
        onClick={() => {
          clickDownloadHandler(
            property.image,
            property.imageType,
            property.imageName,
            service,
            property.analyticsInfo,
            downloadImage,
            sendDownloadEvent
          );
        }}
        disabled={!property.image}
      >
        Download
      </button>
    </div>
  );
};

export default Actions;
